import Map from 'scripts/models/base/map';
import Country from 'scripts/models/api/common/country';
import ImageCloudinary from 'scripts/models/api/image/cloudinary';

export default Map.extend({
    define: {
        identifier: {
              type: 'string',
              value: '' // required
        },
        name: {
            type: 'string',
            value: '' // required
        },
        image: {
            Type: ImageCloudinary,
            Value: '*' // required
        },
        country: {
            Type: Country,
            Value: '*' // required
        },
        isAmateur: {
            type: 'boolean',
            value: false // required
        }
    }
});